import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran10() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "10");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 10" title="Don't Look Down">
        <YouTubeEmbed videoId="A0NrNyaKggQ" title="Don't Look Down — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/10-dont-look-down.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="vi – I⁶ – IV – ii in E major">
        {/* Jason's annotation: vi and IV only  |  chart: C#m, E/G# on beat 4, A, F#m on beat 4 */}
        <RomanNumeralAnalysis
          label="Main progression"
          caption="C#m (two bars, E/G# on the last beat) → A (two bars, F#m on the last beat). Jason writes only vi and IV — the other two are quick passing chords."
          chords={[
            { chord: "C#m",  rn: "vi", function: "Submediant",   pitches: ["C#3","E3","G#3","C#4"] },
            { chord: "E/G#", rn: "I⁶", function: "Tonic",        pitches: ["G#2","E3","G#3","B3"] },
            { bar: true },
            { chord: "A",    rn: "IV", function: "Pre-dominant", pitches: ["A2","C#3","E3","A3"] },
            { chord: "F#m",  rn: "ii", function: "Pre-dominant", pitches: ["F#2","A2","C#3","F#3"] },
          ]}
        />
        <KeyIdea title="The passing bass note">
          C#m lasts two bars, and on beat 4 of the second bar E/G# puts G# in the bass. G# is a
          half step below A, so the bass leans straight up into the A chord (IV). A also lasts two
          bars, with F#m (ii) on beat 4 of the second one before the loop returns to C#m.
        </KeyIdea>
      </Section>
    </LessonShell>
  );
}
